var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('h3', [_vm._v("ACTIVITIES")]), _c('p', {
    staticClass: "px-5"
  }, [_vm._v("Download your activities.")]), _vm.files.length === 0 ? _c('div', {
    staticClass: "p-3"
  }, [_vm._m(0)]) : _vm._e(), _vm._l(_vm.files, function (file, i) {
    return _c('div', {
      key: i,
      staticClass: "card card-stats"
    }, [_c('div', {
      staticClass: "card-body"
    }, [_vm._m(1, true), _c('div', [_c('h5', [_vm._v(_vm._s(file.type))]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(file.date))]), _c('small', {
      staticClass: "mx-2"
    }, [_vm._v("|")]), _c('small', [_vm._v(_vm._s(_vm._f("formatNumber")(file.distance)) + " Km")]), _c('small', {
      staticClass: "mx-2"
    }, [_vm._v("|")]), _c('small', [_vm._v(_vm._s(_vm._f("formatNumber")(file.elevation)) + " Meters")])]), _c('a', {
      staticClass: "download",
      attrs: {
        "href": "javascript:"
      },
      on: {
        "click": function ($event) {
          return _vm.downloadFile(file.id);
        }
      }
    }, [_c('i', {
      staticClass: "icon-download"
    }), _c('span', [_vm._v("download " + _vm._s(file.type))])])])]);
  })], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('p', {
    staticClass: "my-2"
  }, [_vm._v("No Files found for this user")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "img-thumbnail rounded"
  }, [_c('img', {
    staticClass: "text-center",
    attrs: {
      "src": "/favicon.png",
      "alt": "thumbnail"
    }
  })]);
}]

export { render, staticRenderFns }